interface PhaseTimelineProps {
  phases: { id: string; duration: number }[];
  currentPhase: string;
  cyclePosition: number;
  cycleTime: number;
}

const phaseColors: Record<string, string> = {
  A: 'bg-green-600',
  B: 'bg-yellow-500',
  C: 'bg-green-600',
  D: 'bg-yellow-500',
  E: 'bg-red-600',
  F: 'bg-green-400',
};

export function PhaseTimeline({
  phases,
  currentPhase,
  cyclePosition,
  cycleTime
}: PhaseTimelineProps) {
  const progressPercent = cycleTime > 0 ? (cyclePosition / cycleTime) * 100 : 0;

  return (
    <div className="px-3 py-2 min-w-[320px]">
      {/* Phase bar */}
      <div className="flex h-6 rounded overflow-hidden relative">
        {phases.map((phase) => {
          const widthPercent = cycleTime > 0 ? (phase.duration / cycleTime) * 100 : 0;
          const isCurrent = phase.id === currentPhase;

          return (
            <div
              key={phase.id}
              className={`
                relative flex items-center justify-center text-[10px] font-mono font-bold
                transition-all duration-200
                ${phaseColors[phase.id] || 'bg-gray-600'}
                ${isCurrent ? 'opacity-100 text-white' : 'opacity-40 text-white/60'}
              `}
              style={{ width: `${widthPercent}%` }}
            >
              {phase.id}
            </div>
          );
        })}

        {/* Position indicator */}
        <div
          className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_6px_rgba(255,255,255,0.8)]"
          style={{ left: `${progressPercent}%` }}
        />
      </div>

      {/* Info line */}
      <div className="flex justify-between mt-1.5 text-[10px] font-mono text-gray-400">
        <span>Fase <span className="text-white font-bold">{currentPhase}</span></span>
        <span>
          {(cyclePosition / 10).toFixed(1)}s / {(cycleTime / 10).toFixed(0)}s
        </span>
      </div>
    </div>
  );
}
